import {
  editAddr,
  editDelivery,
  delDelivery,
  addSellerAddr
} from "@/api/addr/addr";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    // 获取进货车列表
    async editAddr(context, params) {
      const data = await editAddr(params);
      return data;
    },
    async editDelivery(context, params) {
      const data = await editDelivery(params);
      return data;
    },
    async delDelivery(context, params) {
      const data = await delDelivery(params);
      return data;
    },
    async addSellerAddr(context, params) {
      const data = await addSellerAddr(params);
      return data;
    }
  }
};
